module.exports = __webpack_public_path__ + "static/media/Delta_format.a74c263a.png";